/**
 * <s-notice-popup> — opens the wrapped <dialog> once per browser visit.
 * Wrap an <s-dialog> (which handles backdrop click, Escape and focus restore).
 * After the visitor closes it, it stays closed until they come back in a new visit.
 *
 * Attributes:
 *   storage-key — sessionStorage key that remembers the dismissal (default: "notice-popup")
 */
class SNoticePopup extends HTMLElement {
  #ac;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    const key = this.getAttribute('storage-key') || 'notice-popup';
    this.#ac = new AbortController();

    dialog.addEventListener(
      'close',
      () => {
        try {
          sessionStorage.setItem(key, '1');
        } catch (e) {
          /* storage unavailable: popup simply shows again next page */
        }
      },
      { signal: this.#ac.signal }
    );

    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(key) === '1';
    } catch (e) {
      dismissed = false;
    }

    if (!dismissed && !dialog.open) {
      requestAnimationFrame(() => {
        if (this.isConnected && !dialog.open) dialog.showModal();
      });
    }
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-notice-popup')) customElements.define('s-notice-popup', SNoticePopup);
